<template>
  <div id="Laddress">
    <div class="laddressFirst">
      <div class="laddressFirstLeft">快递地址</div>
      <div class="laddressFirstBtn" @click="newaddss()">新增</div>
    </div>
    <div>
      <Table :columns="columns1" :data="data1">
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <i-switch true-color="#3562E8"  v-model="row.isDefault" @on-change="handleChang(row, index)"/>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <div>
            <span class="bianji" @click="bianji(row,index)">编辑</span>
            <span class="del" @click="del(row)">删除</span>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getAddress, postIsDefault } from "../../../network/LPersonal";
import { delAddress } from "../../../network/order2";
export default {
  data() {
    return {
      columns1: [
        {
          title: "地址",
          key: "address",
        },
        {
          title: "邮编",
          key: "postalCode",
        },
        {
          title: "默认状态",
          slot: "action",
          width: 100,
        },
        {
          title: "操作",
          slot: "action1",
          width: 150,
          
        },
      ],
      data1: [],
    };
  },
  created() {
    this.get();
    this.uid = this.Get("userId");
    this.$emit("editPage", "账户资料", "快递地址");
  },
  activated(){
    this.$emit("editPage", "账户资料", "快递地址");
  },
  methods: {
    del(row){
       console.log(row);
       delAddress(row.id).then(r=>{
         console.log(r);
         if(r.data.code==200){
           this.$Message.success(r.data.msg)
           this.get()
         }
       })
    },
    bianji(row,index){
      console.log(row,index);
        this.$router.push({
          name: "newaddress1",
          query: {
            data: encodeURIComponent(JSON.stringify(row)),
          },
        });
    },
    newaddss(){
       this.$router.push("/newaddress")
    },
    handleChang(row, index) {
      // this.$Message.info('开关状态：' + status);
      console.log(row,"默认状态");
      let from = {
        addressId: row.id,
        isDefault: row.isDefault == true ? 1 : 0,
      };
      postIsDefault(from).then((res) => {
        //  this.$Message.success('修改成功');
        if (res.data.code == 200) {
          this.$Message.success("修改成功");
          this.get()
        }
      });
    },
    Get(name) {
      return Cookies.get(`admin-${name}`);
    },
    get() {
      let from = {
        userId: this.Get("userId"),
      };
      getAddress(from).then((res) => {
        console.log(res.data.data, "快递地址列表");
        res.data.data.forEach((element, i) => {
          // if(element.isDefault){
          res.data.data[i].isDefault = element.isDefault == 1 ? true : false;
          // }
        });
        this.data1 = res.data.data;
        console.log(this.data1);
      });
    },
  },
};
</script>

<style>
@import url("../../../assets/css/liucss/address.css");
</style>